<script>
  export let data = [];

  import { Doughnut } from "svelte-chartjs";

  import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    CategoryScale,
  } from "chart.js";

  ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);
</script>

<div>
  <Doughnut {data} options={{ responsive: true }} />
  <i style="font-size: 13px; opacity: 0.5;">% of total votes</i>
</div>
